import { parseLocalDate } from './dateOnly';

export function getServiceTypeDisplay(serviceType) {
  if (serviceType === null || serviceType === undefined || serviceType === '') return 'General';
  const raw = String(serviceType).trim().toLowerCase();
  if (raw === '1' || raw === 'general') return 'General';
  if (raw === '2' || raw === 'call via others') return 'Call via others';
  if (raw === '10' || raw === 'care plan review') return 'Care plan review';
  if (raw === '11' || raw === 'medication management') return 'Medication management';
  if (raw === '12' || raw === 'patient education') return 'Patient education';
  if (raw === '13' || raw === 'care coordination') return 'Care coordination';
  if (raw === '14' || raw.includes('symptom')) return 'Symptom / condition follow-up';
  if (raw === '15' || raw === 'other') return 'Other';
  return String(serviceType);
}

/** Service minutes billed/stored on the follow-up (RPM + CCM). */
export function getFollowUpServiceMinutes(row) {
  const direct = Number.parseInt(row?.service_time, 10);
  if (Number.isFinite(direct) && direct >= 0) return direct;

  const timer = String(row?.timerValue || '').trim();
  if (timer.includes(':')) {
    const [m = '0', s = '0'] = timer.split(':');
    const mins = Number.parseInt(m, 10) || 0;
    const secs = Number.parseInt(s, 10) || 0;
    return Math.max(0, mins + (secs > 30 ? 1 : 0));
  }
  return 0;
}

function extractClockFromCreatedAt(createdAt) {
  if (!createdAt) return null;
  const d = new Date(createdAt);
  if (Number.isNaN(d.getTime())) return null;
  const hh = String(d.getHours()).padStart(2, '0');
  const mm = String(d.getMinutes()).padStart(2, '0');
  return `${hh}:${mm}`;
}

/**
 * Legacy rows stored session timer (MM:SS) in `time` instead of clock time.
 */
export function isLegacyServiceTimerInTimeColumn(timeStr, serviceMinutes) {
  const raw = String(timeStr || '').trim();
  if (!/^\d{1,2}:\d{2}$/.test(raw)) return false;
  const [minsPart, secsPart] = raw.split(':').map((v) => Number.parseInt(v, 10) || 0);
  const st = Number.parseInt(serviceMinutes, 10) || 0;
  if (st <= 0) return false;
  if (minsPart === st && secsPart < 60) return true;
  if (minsPart === st && secsPart === 0) return true;
  return false;
}

export function resolveFollowUpClockTime(row) {
  const timeStr = String(row?.time || '').trim();
  const serviceMinutes = getFollowUpServiceMinutes(row);

  if (timeStr && !isLegacyServiceTimerInTimeColumn(timeStr, serviceMinutes)) {
    if (/^\d{2}:\d{2}(:\d{2})?$/.test(timeStr)) {
      return timeStr.substring(0, 5);
    }
  }

  return extractClockFromCreatedAt(row?.created_at) || '00:00';
}

export function formatFollowUpDateTime(row) {
  const dateRaw = row?.date || row?.created_at || row?.date_time;
  const date = parseLocalDate(dateRaw);
  if (!date) return 'N/A';

  const clock = resolveFollowUpClockTime(row);
  const [hhRaw, mmRaw] = clock.split(':');
  const hours24 = Number.parseInt(hhRaw, 10) || 0;
  const minutes = String(Number.parseInt(mmRaw, 10) || 0).padStart(2, '0');
  const ampm = hours24 >= 12 ? 'PM' : 'AM';
  const displayHours = hours24 % 12 || 12;

  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const year = date.getFullYear();

  return `${month}-${day}-${year}/${String(displayHours).padStart(2, '0')}:${minutes} ${ampm}`;
}

export function formatFollowUpNoteFooter(row) {
  const serviceType = getServiceTypeDisplay(row?.service_type).toUpperCase();
  const minutes = getFollowUpServiceMinutes(row);
  return `${serviceType} · ${minutes} MIN`;
}

export function splitFollowUpServiceTimer(row) {
  const minutes = getFollowUpServiceMinutes(row);
  return {
    minutes: String(minutes),
    seconds: '00'
  };
}
